/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Plan_Save_Per_YearInputs */

const en_plan_save_per_year = /** @type {(inputs: Plan_Save_Per_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Save ${i?.amount} per year`)
};

const es_plan_save_per_year = /** @type {(inputs: Plan_Save_Per_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ahorra ${i?.amount} por año`)
};

/**
* | output |
* | --- |
* | "Save {amount} per year" |
*
* @param {Plan_Save_Per_YearInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_save_per_year = /** @type {((inputs: Plan_Save_Per_YearInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Save_Per_YearInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_save_per_year(inputs)
	return en_plan_save_per_year(inputs)
});